import React, { useState } from 'react';
import { Mail, Menu, X } from 'lucide-react';
import { getAppPublicPathUrl, getRootDomainUrl } from '../utils/tenant';
import { useTheme } from '../contexts/ThemeContext.tsx';

function HomePageHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { logoUrl } = useTheme();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-blue-800 shadow-sm relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <a href={getRootDomainUrl('/')} className="block">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt="Organization logo"
                  className="h-8 w-auto object-contain"
                />
              ) : (
                <h1
                  className="text-2xl font-bold text-white"
                  style={{
                    fontFamily: "'Inter', 'SF Pro Display', -apple-system, sans-serif",
                    letterSpacing: "0.2em",
                    fontWeight: "700",
                    textTransform: "uppercase",
                  }}
                >
                  SKEPTICS
                </h1>
              )}
            </a>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-3">
            <a
              href={getRootDomainUrl('/contact')}
              className="group flex items-center py-2 text-sm font-medium text-blue-100 hover:text-white transition-all"
            >
              <Mail className="h-4 w-4 mr-2 group-hover:scale-110 transition-transform" />
              Contact Us
            </a>
            <a
              href={getAppPublicPathUrl('/signin')}
              className="px-5 py-2 rounded-md text-sm font-medium text-blue-100 hover:text-white transition-colors"
            >
              Sign In
            </a>
            <a
              href={getAppPublicPathUrl('/signup')}
              className="px-5 py-2 rounded-md text-sm font-medium bg-white text-blue-800 hover:bg-gray-100 transition-colors"
            >
              Request Access
            </a>
          </div>

          {/* Mobile Hamburger Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white transition-colors"
            aria-expanded={isMenuOpen}
          >
            <span className="sr-only">{isMenuOpen ? 'Close menu' : 'Open menu'}</span>
            {isMenuOpen ? (
              <X className="block h-6 w-6" />
            ) : (
              <Menu className="block h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 bg-blue-800 shadow-lg z-50">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a
              href={getRootDomainUrl('/contact')}
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center px-3 py-2 rounded-md text-base font-medium text-blue-100 hover:text-white hover:bg-blue-700 transition-colors"
            >
              <Mail className="h-5 w-5 mr-3" />
              Contact Us
            </a>
            <a
              href={getAppPublicPathUrl('/signin')}
              onClick={() => setIsMenuOpen(false)}
              className="block px-3 py-2 rounded-md text-base font-medium text-blue-100 hover:text-white hover:bg-blue-700 transition-colors"
            >
              Sign In
            </a>
            <a
              href={getAppPublicPathUrl('/signup')}
              onClick={() => setIsMenuOpen(false)}
              className="block px-3 py-2 rounded-md text-base font-medium bg-white text-blue-800 hover:bg-gray-100 transition-colors"
            >
              Request Access
            </a>
          </div>
        </div>
      )}
    </header>
  );
}

export default HomePageHeader;